import type React from 'react';

type E = KeyboardEvent | React.KeyboardEvent;

const keymap = {
  isEscape: (e: E) => e.key === 'Escape',
  isEnter: (e: E) => e.key === 'Enter',
  isArrowDown: (e: E) => e.key === 'ArrowDown',
  isArrowUp: (e: E) => e.key === 'ArrowUp',
  isBackspace: (e: E) => e.key === 'Backspace',
  isSpace: (e: E) => e.key === ' ',
};

export default keymap;
